/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { WeatherSunMoonIcon16Light } from './WeatherSunMoonIcon16Light';
import { WeatherSunMoonIcon16Regular } from './WeatherSunMoonIcon16Regular';
import { WeatherSunMoonIcon16Solid } from './WeatherSunMoonIcon16Solid';
import { WeatherSunMoonIcon20Light } from './WeatherSunMoonIcon20Light';
import { WeatherSunMoonIcon20Regular } from './WeatherSunMoonIcon20Regular';
import { WeatherSunMoonIcon20Solid } from './WeatherSunMoonIcon20Solid';
import { WeatherSunMoonIcon24Regular } from './WeatherSunMoonIcon24Regular';
import { WeatherSunMoonIcon24Solid } from './WeatherSunMoonIcon24Solid';
import { WeatherSunMoonIcon32Regular } from './WeatherSunMoonIcon32Regular';
import { WeatherSunMoonIcon64Regular } from './WeatherSunMoonIcon64Regular';
var sizes = {
    16: {
        light: WeatherSunMoonIcon16Light,
        regular: WeatherSunMoonIcon16Regular,
        solid: WeatherSunMoonIcon16Solid,
    },
    20: {
        light: WeatherSunMoonIcon20Light,
        regular: WeatherSunMoonIcon20Regular,
        solid: WeatherSunMoonIcon20Solid,
    },
    24: {
        regular: WeatherSunMoonIcon24Regular,
        solid: WeatherSunMoonIcon24Solid,
    },
    32: {
        regular: WeatherSunMoonIcon32Regular,
    },
    64: {
        regular: WeatherSunMoonIcon64Regular,
    },
};
export var WeatherSunMoonIcon = forwardRef('WeatherSunMoonIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
